import React from 'react';

import { CONSORS_NOTE_SOURCES } from 'cpool-constants';
import type { SchemaConsorsNote } from 'cpool-schemas';
import { useTranslation } from 'react-i18next';

import { dateTimeFormat } from '~/lib/i18n';
import { cn } from '~/utils/cnTailwind';

interface NoteListItemProps {
    note: SchemaConsorsNote;
}

export const NoteListItem: React.FC<NoteListItemProps> = ({ note }) => {
    const { t } = useTranslation();
    return (
        <div className="bg-white p-4 rounded-lg shadow-sm mb-4">
            <div
                className={cn(
                    'flex justify-between text-xs text-grey mb-2',
                    note.source === CONSORS_NOTE_SOURCES.CPOOL && 'text-blue',
                    note.source === CONSORS_NOTE_SOURCES.CONSORS && 'text-green',
                )}
            >
                <span>
                    {note.data.creationDate
                        ? dateTimeFormat(new Date(note.data.creationDate))
                        : t('CONSORS_NOTES.DATE_MISSING')}
                </span>
                <span>{note.data.employeeName}</span>
            </div>
            <div className="text-sm text-grey">{note.data.content}</div>
        </div>
    );
};
